import React, { forwardRef } from 'react'

import CursorManagedInput from './CursorManagedInput'

const ParsedInput = forwardRef(({ onChange, parse, ...props }, ref) => {
  const handleChange = (e, data) => {
    if (!parse) {
      if (onChange) onChange(e, data)
      return
    }

    let caretPositionIndex = e.target.selectionStart
    const value = e.target.value
    const parsedValue = parse(value)
    caretPositionIndex += parsedValue.length - value.length
    // eslint-disable-next-line no-param-reassign
    e.target.value = parsedValue
    e.target.setSelectionRange(caretPositionIndex, caretPositionIndex)

    if (onChange) onChange(e, { ...data, value: parsedValue })
  }

  return <CursorManagedInput {...props} onChange={handleChange} ref={ref} />
})

export default ParsedInput
